module.exports = __webpack_public_path__ + "static/img/lrs_baichi_img@2x.c0b76ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lrsimages/rules/lrs_baichi_img@2x.png
// module id = jy8K
// module chunks = 23